module.exports = __webpack_public_path__ + "img/2_7.3bc2a4f4.png";